import { Message } from "primereact/message";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { TourAnchor } from "training/anchors";

const StyledMessage = styled(Message)`
  max-width: 905px;
`;

interface IDuplicateOrderWarningProps {
  orderId: string;
}

export function DuplicateOrderWarning({
  orderId,
}: IDuplicateOrderWarningProps) {
  return (
    <StyledMessage
      data-tour={TourAnchor.DuplicateWarning}
      severity="warn"
      text={
        <>
          We found a potential duplicate order. Please review it - if it&apos;s
          a duplicate, cancel this one; otherwise, proceed. <br />
          Order ID:{" "}
          <Link target="_blank" to={`/orders/${orderId}`}>
            {orderId}
          </Link>
        </>
      }
    />
  );
}
